import { useTranslation } from 'react-i18next';
import { CustomSwitch } from '../../../../components/CustomSwitch';
/**
 * @Author: Susana García Rodríguez
 * @JobTitle: Frontend Developer - IBL
 * @Email: sgarcia@ibl.mx
 */
/**
 * UserRestrictionItem
 *
 * Reusable component that renders a configuration/restriction item
 * with a title, optional description, and a toggle switch (CustomSwitch).
 *
 * Responsive behavior:
 * - Mobile: title (9 cols) and switch (3 cols) displayed on the same row.
 * - Desktop: maintains a 9/3 column layout.
 *
 * @param {Object} props
 * @param {string} props.id - Unique identifier for the switch component.
 * @param {string} props.name - Name attribute associated with the switch input.
 * @param {string} props.title - Translation key for the main title.
 * @param {string} [props.description] - Translation key for the optional description displayed below the title.
 * @param {boolean} props.checked - Controlled state of the switch.
 * @param {(event: React.ChangeEvent<HTMLInputElement>) => void} props.onChange - Callback function triggered when the switch state changes.
 * @param {boolean} [props.disabled=false] - Determines whether the switch is disabled.
 * @param {string} [props.className=''] - Additional CSS classes applied to the root container.
 *
 * @returns {JSX.Element}
 */
export const UserRestrictionItem = ({
    id,
    name,
    title,
    description,
    checked,
    onChange,
    disabled = false,
    className = '',
}) => {
    const { t } = useTranslation();

    return (
        <div className={`mb-3 background-shades-50 border-radius-8px  p-3 ${className}`}>
            <div className='row align-items-start'>
                <div className='col-9'>
                    <p className='fs-14px ibl-font-w-600 font-color-general-950 mb-0'>{t(title)}</p>
                    {description && (
                        <p className='fs-12px ibl-font-w-400 font-color-general-950 mt-1 mb-0'>{t(description)}</p>
                    )}
                </div>
                <div className='col-3 d-flex justify-content-end'>
                 <CustomSwitch id={id} name={name} disabled={disabled} checked={checked} onChange={onChange} showBorder={false}/>
                </div>
            </div>
        </div>
    );
};
